import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmailHeaderProps {
  subject: string;
  emailSent: boolean;
  isExpanded?: boolean;
  hasGenerated?: boolean;
  onClick?: () => void;
}

const EmailHeader = ({ 
  subject, 
  emailSent, 
  isExpanded, 
  hasGenerated,
  onClick
}: EmailHeaderProps) => {
  const handleClick = (e: React.MouseEvent) => {
    // Prevent the click from bubbling up
    e.stopPropagation();
    onClick?.();
  };

  return (
    <div 
      className="flex items-center justify-between cursor-pointer p-2 hover:bg-gray-50 rounded-lg"
      onClick={onClick}
    >
      <div className="flex items-center space-x-4">
        <h3 className="text-lg font-semibold">{subject}</h3>
        {emailSent && (
          <span className="text-green-600 text-sm font-medium">
            Email Sent ✓
          </span>
        )}
      </div>
      {hasGenerated && (
        <Button 
          variant="ghost" 
          size="sm"
          onClick={handleClick}
        >
          {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </Button>
      )}
    </div>
  );
};

export default EmailHeader;